/* Consider these like trigger fns */

// Triggers when siteid changes
export function siteId(siteId) {
	return {
		type: 'SITEID_CHANGED',
		siteId,
	};
}

// Get account's file structure
export function fileFetchHasErrored(hasErrored) {
	return {
		type: 'FILE_STRUCTURE_LOAD_FAILED',
		hasErrored,
	};
}
export function fileFetchIsLoading(isLoading) {
	return {
		type: 'FILE_STRUCTURE_ISLOADING',
		isLoading,
	};
}
export function fileStructure(files) {
	return {
		type: 'FILE_STRUCTURE_LOADED',
		files,
	};
}

// Hide and show the file tree
export function isFileStructureShowing(status) {
	return {
		type: 'STRUCT_STATUS',
		status,
	};
}

// Get current folder which is open
export function openedFolder(folder) {
	return {
		type: 'FOLDER_OPEN',
		folder,
	};
}

// Get current file which is open
export function openedFile(file) {
	return {
		type: 'FILE_OPEN',
		file,
	};
}

// Get revision history
export function revisionFetchHasErrored(hasErrored) {
	return {
		type: 'REVISION_LOAD_FAILED',
		hasErrored,
	};
}
export function revisionFetchIsLoading(isLoading) {
	return {
		type: 'REVISION_ISLOADING',
		isLoading,
	};
}
export function revision(revision) {
	return {
		type: 'REVISION_LOADED',
		revision,
	};
}

// The two revisions which are diff'ed
export function sourceRevision(rev) {
	return {
		type: 'SOURCE_REVISION',
		rev,
	};
}

export function targetRevision(rev) {
	return {
		type: 'TARGET_REVISION',
		rev,
	};
}

// Get xml source file
export function xmlSourceFetchHasErrored(hasErrored) {
	return {
		type: 'XML_SOURCE_LOAD_FAILED',
		hasErrored,
	};
}
export function xmlSourceFetchIsLoading(isLoading) {
	return {
		type: 'XML_SOURCE_ISLOADING',
		isLoading,
	};
}
export function xmlSourceFile(file) {
	return {
		type: 'XML_SOURCE_LOADED',
		file,
	};
}

// Get xml target file
export function xmlTargetFetchHasErrored(hasErrored) {
	return {
		type: 'XML_TARGET_LOAD_FAILED',
		hasErrored,
	};
}
export function xmlTargetFetchIsLoading(isLoading) {
	return {
		type: 'XML_TARGET_ISLOADING',
		isLoading,
	};
}
export function xmlTargetFile(file) {
	return {
		type: 'XML_TARGET_LOADED',
		file,
	};
}

export function updateDiffContextDisplay(showDiffContext) {
	return {
		type: 'UPDATE_DIFF_CONTEXT_DISPLAY',
		showDiffContext,
	};
}
